// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  SessionType,
  SessionAccess,
  SessionStatus,
} from "./types";


export default __t.row({
  sessionId: __t.u64().primaryKey().name("session_id"),
  scope: __t.option(__t.string()),
  get sessionType() {
    return SessionType.name("session_type");
  },
  title: __t.option(__t.string()),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  get status() {
    return SessionStatus;
  },
  get access() {
    return SessionAccess;
  },
  metadataJson: __t.option(__t.string()).name("metadata_json"),
  canonicalKey: __t.option(__t.string()).name("canonical_key"),
});
